import React from "react";

export function OverviewSection() {
  return (
    <section className="flex flex-col gap-6">
      <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <h2 className="text-xl font-semibold text-gray-900">Welcome to the Admin Panel</h2>
        <p className="mt-3 text-sm text-gray-600">
          Use this workspace to curate community content, manage members, and keep the
          WeAttitude experience aligned with your vision. Start with the overview below and
          jump into a section when you are ready to take action.
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="rounded-lg border border-indigo-100 bg-indigo-50 p-5">
          <h3 className="text-base font-semibold text-indigo-900">Content Lifecycle</h3>
          <p className="mt-2 text-sm text-indigo-800">
            Soft deletion keeps contributions visible to their authors while hiding them from the
            wider community. Upcoming permanent deletion tools will let you remove issues,
            solutions, and action groups entirely.
          </p>
        </div>
        <div className="rounded-lg border border-teal-100 bg-teal-50 p-5">
          <h3 className="text-base font-semibold text-teal-900">Visual Identity</h3>
          <p className="mt-2 text-sm text-teal-800">
            Fresh background imagery and theme colours keep the platform feeling lively.
            Upload new assets, pair them with colours, and the experience updates instantly.
          </p>
        </div>
      </div>
    </section>
  );
}
